import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Loader2, Send, Check } from 'lucide-react';

const ContactPage = () => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const maxChars = 200;

  const handleSend = async () => {
    if (!message.trim()) {
      toast.error('Digite uma mensagem');
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/students/contact`, {
        message: message.trim(),
        subject: 'Mensagem do Aluno'
      });
      toast.success('Mensagem enviada com sucesso!');
      setSent(true);
      setMessage('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao enviar mensagem');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="student-contact-page">
      <div>
        <h2 className="text-2xl font-bold text-slate-900">Fale Conosco</h2>
        <p className="text-slate-500 text-sm">Envie uma mensagem para a equipe Vital Performance</p>
      </div>

      <Card className="max-w-lg">
        <CardContent className="pt-6 space-y-4">
          {sent ? (
            <div className="text-center py-8" data-testid="contact-success">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <Check className="w-8 h-8 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-1">Mensagem Enviada!</h3>
              <p className="text-slate-500 text-sm mb-6">Sua mensagem foi encaminhada para nossa equipe. Responderemos em breve.</p>
              <Button variant="outline" onClick={() => setSent(false)} data-testid="send-another-btn">
                Enviar outra mensagem
              </Button>
            </div>
          ) : (
            <>
              <div className="space-y-2">
                <Label className="text-sm font-medium text-slate-700">Destinatário</Label>
                <div className="px-3 py-2 bg-slate-50 rounded-lg text-sm text-slate-600 border border-slate-200">
                  contato@vitalperformance.app.br
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <Label htmlFor="contact-message" className="text-sm font-medium text-slate-700">Sua mensagem</Label>
                  <span className={`text-xs ${message.length > maxChars ? 'text-red-500 font-medium' : 'text-slate-400'}`}>
                    {message.length}/{maxChars}
                  </span>
                </div>
                <textarea
                  id="contact-message"
                  data-testid="contact-message-input"
                  className="w-full min-h-[120px] px-3 py-2 border border-slate-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all"
                  placeholder="Escreva sua mensagem aqui..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value.slice(0, maxChars))}
                  maxLength={maxChars}
                />
              </div>

              <Button
                onClick={handleSend}
                disabled={sending || !message.trim() || message.length > maxChars}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
                data-testid="send-contact-btn"
              >
                {sending ? (
                  <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Enviando...</>
                ) : (
                  <><Send className="w-4 h-4 mr-2" /> Enviar Mensagem</>
                )}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactPage;
